import './index.css';

const Home = () => {
    return(
        <div>
            <h1 className="color3">This is Home page.</h1>
        </div>
    );   
};
export default Home;